import { DEFAULT_COLORS } from '../Base/constants';

export default class BarChartStyle {
  public barColor = DEFAULT_COLORS.primary;
  public barWidth = 5;

  constructor() {}

  public setBarColor(color: string) {
    this.barColor = color;
  }

  public setBarWidth(width: number) {
    this.barWidth = width;
  }

  public useStyles() {}
}
